import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 0h24v24H0z" }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-opacity": ".85",
    d: "M13.596 7.322c2.26-2.072 5.904-.468 5.904 2.597 0 .935-.371 1.83-1.032 2.492L12 18.879 5.532 12.41A3.52 3.52 0 0 1 4.5 9.919c0-3.065 3.644-4.669 5.904-2.597L12 8.785zM3 9.919c0 1.333.53 2.61 1.471 3.552l7.31 7.31c.121.121.317.121.438 0l7.31-7.31A5.02 5.02 0 0 0 21 9.92c0-4.37-5.196-6.656-8.418-3.703L12 6.75l-.582-.534C8.196 3.263 3 5.548 3 9.92"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }